import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, timer } from 'rxjs';
import { take } from 'rxjs/operators';
import { ASSET_NAME } from 'src/app/app.consts';
import { ApplicationsApiService } from 'src/app/services/api/applications-api.service';
import { ApplicationService } from 'src/app/services/application-service';
import { FlowService } from 'src/app/services/flow.service';
import { TrackingService } from 'src/app/services/tracking.service';
import { handleApiError } from 'src/app/utils/error';

@Component({
  selector: 'app-big-ticket-purpose',
  templateUrl: './big-ticket-purpose.component.html',
  styleUrls: ['./big-ticket-purpose.component.scss']
})

export class BigTicketPurposeComponent implements OnInit, OnDestroy {
  applicationId!: number;
  purposeForm!: FormGroup;
  error!: string;
  assetName!: typeof ASSET_NAME;
  subs: Array<Subscription> = [];
  requestPending = false;
  @Input() isSummary!: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private translateService: TranslateService,
    private applicationService: ApplicationService,
    private applicationsApiService: ApplicationsApiService,
    public flowService: FlowService,
    protected trackingService: TrackingService 
  ) { }

  ngOnInit(): void {
    this.applicationId = this.applicationService.applicationId;

    const initialReasonDescription = this.applicationService.reasonDescription || '';
    const initialOtherSecuritiesFiles = this.applicationService.otherSecuritiesFiles || [];

    this.purposeForm = this.formBuilder.group({
      reasonDesc: [initialReasonDescription, { updateOn: 'blur' }],
      otherSecuritiesFiles: this.formBuilder.array(initialOtherSecuritiesFiles),
    });

    this.assetName = ASSET_NAME;
  }

  ngOnDestroy(): void {
    this.subs.map((s) => s.unsubscribe());
  }

  trackFields(field: string): void {
    this.trackingService.filledField(field);
  }

  reasonDescriptionUpdate(): void {
    this.requestPending = true;
    const description = this.reasonDesc.value;
    this.applicationService.reasonDescription = description;
    this.subs.push(this.applicationsApiService
      .updateApplication({
        reasonDesc: description,
        applicationId: this.applicationId,
      })
      .pipe(take(1))
      .subscribe(
        () => {
          this.error = '';
          this.trackFields('reasonDesc');
        },
        (error: any) => handleApiError(error, this.translateService),
        () => this.requestPending = false
      ));
  }

  handleContinueButtonClick(): void {
    this.subs.push(timer(1000, 1000).subscribe(() => {
      if (!this.requestPending) {
        this.flowService.nextScreen();
      }
    }));
  }

  get form(): FormGroup {
    return this.purposeForm;
  }

  get reasonDesc(): FormControl {
    return this.form.get('reasonDesc') as FormControl;
  }

  get otherSecuritiesFiles(): FormArray {
    return this.form.get('otherSecuritiesFiles') as FormArray;
  }
}
